import { ContainerStatus, Event, Location } from "../models/marine.traffic";
import { Shipment } from "../models/shipments";

type CallbackProps = {
  shipment: Shipment;
  containerStatus: ContainerStatus;
  departureLocation?: Location;
  containerAtPOLEvent?: Event;
};

export interface MarineStatusProps {
  shipment: Shipment;
  containerStatus: ContainerStatus;
  callback: (valus: CallbackProps) => void;
}

export const validateAndUpdateFromMarineStatus = ({
  shipment,
  containerStatus,
  callback,
}: MarineStatusProps) => {
  if (!shipment || !containerStatus) return;

  const { routes, events, locations } = containerStatus.transportationPlan;
  const containerAtPOLTypeCode: string = "CGI";
  const departureEventId: number = routes[0].departure.eventId;

  const departureEvent = events.find((event: Event) => event.eventId === departureEventId);
  const containerAtPOLEvent = events.find(
    (event: Event) => event.eventTypeCode === containerAtPOLTypeCode
  );
  const departureLocation = locations.find(
    (location: Location) => location.portId === departureEvent?.location.portId
  );

  let differentFromMarine: boolean = false;

  if (departureLocation?.locationName && shipment?.origin !== departureLocation?.locationName)
    differentFromMarine = true;
  else if (containerStatus.finalPortName && shipment?.destination !== containerStatus.finalPortName)
    differentFromMarine = true;
  else if (containerStatus.vesselName && shipment?.vesselName !== containerStatus.vesselName)
    differentFromMarine = true;
  else if (
    containerStatus.finalPortPredictiveArrivalUtc &&
    shipment?.etaFinalPort !== new Date(containerStatus.finalPortPredictiveArrivalUtc).toISOString()
  )
    differentFromMarine = true;
  else if (
    containerStatus.finalPortActualArrivalUtc &&
    shipment?.arriveDc !== new Date(containerStatus.finalPortActualArrivalUtc).toISOString()
  )
    differentFromMarine = true;
  else if (
    containerAtPOLEvent?.eventDatetime &&
    shipment?.actualDateDeparture !== new Date(containerAtPOLEvent?.eventDatetime).toISOString()
  )
    differentFromMarine = true;

  if (differentFromMarine) {
    callback({
      shipment,
      containerStatus,
      departureLocation,
      containerAtPOLEvent,
    });
  }
};
